/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('ServiceCtrl',["$scope","$dialog","$timeout","CategorySrv","CategoryData","Category","ServiceSrv",
    "ServiceData","Service","ImageData","ServiceView","CategoryView", "StyleData","HumanResourceData",
    "HumanResourceView","PhysicalResourceData","PhysicalResourceView","ProductCategoryView","ProductCategoryData",
    "LanguageManager","CureSrv","gettextCatalog","ServiceSettingsReserveWithGoogleSrv",
    "ServiceSettingsReserveWithGoogleView","ServiceSettingsLeCiseauSrv","ServiceSettingsLeCiseauView",
    "ServiceSettingsLeCiseauData","BasicAuthRole","LaunchDarklyFeatureFlagList","LaunchDarklyFeatureFlagData",
    "MarketplaceSrv",
        function($scope,$dialog,$timeout,CategorySrv,CategoryData,Category,ServiceSrv,
                 ServiceData,Service,ImageData,ServiceView,CategoryView,StyleData,HumanResourceData,
                 HumanResourceView,PhysicalResourceData,PhysicalResourceView,ProductCategoryView,ProductCategoryData,
                 LanguageManager,CureSrv,gettextCatalog,ServiceSettingsReserveWithGoogleSrv,
                 ServiceSettingsReserveWithGoogleView, ServiceSettingsLeCiseauSrv,ServiceSettingsLeCiseauView,
                 ServiceSettingsLeCiseauData,BasicAuthRole,LaunchDarklyFeatureFlagList,LaunchDarklyFeatureFlagData,
                 MarketplaceSrv)
{
    $scope.dd =
    {
        view :
        {
            categoryRootView : null,
            cCategoryView : null,
            servicesViewIndex : [],//Keep index
            deletedCategoriesView : [],
            deletedServicesView : [],
            imagesView : [],
            imagesViewFiltered : [],
            humanResourcesView : [],
            hsHr:true,
            physicalResourcesView : [],
            hsPr : true,
            styles : StyleData.styles,
            displaySubConf : 1,
            tab : 1,
            subTab:1,
            displayError : false,  //Used  to display error message when user click on save,
            filterServicesView : null,
            filterTimeOut : null,
            filterTypeService : "",
            filterTypeServiceList :
                {
                    allServices : "all",
                    website : "website",
                    reserveWithGoogle : "reserveWithGoogle"
                },
            filter : "",
            selected : {
                categoryView : null,
                serviceView : null
            },
            edited :
            {
                categoryView : null,
                serviceView : null
            },
            serviceLoading : false,
            categoriesLoading : false,
            marketplaceData: {
                marketplaceCategories: [],
                marketplaceSubCategories: [],
                marketplaceVariants: [],
                defaultData: {
                    marketplaceDefaultPromoEnabled: true,
                    marketplaceDefaultCategory: {id: null},
                    marketplaceDefaultSubCategory: {id: null},
                    marketplaceDefaultVariant: {id: null}
                },
                loaded: false
            }
        },
        flowConfig : {
            target: '/rest/companyImageUpload',
            method:'octet',
            query : {companyCode: $scope.ad.companyCode,type:'service'},
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 1,
            chunkSize : 1024*1024*5,
            singleFile: true,
            testChunks:false,
            headers: {Authorization: $scope.ad.currentUser.token}
        },
        isDuplicatingCategory : false
    };

    $scope.basicAuthRole = BasicAuthRole;

    $scope.$watch('ad.dataLoaded', function(newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
            $scope.dd.view.categoryRootView = new CategoryView(CategoryData.categoryRoot,CategoryData.getIndexOf(CategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot,ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            $scope.dd.view.categoryRootView.loadProductsView();
            $scope.dd.view.cCategoryView =  $scope.dd.view.categoryRootView;
            $scope.dd.view.cProductCategoryView =  $scope.dd.view.productCategoryRootView;
            $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;
            $scope.dd.view.humanResourcesView = [];
            $scope.dd.view.physicalResourcesView = [];
            var humanResources =  HumanResourceData.getActiveList();
            var hrView;
            for(var i=0;i<humanResources.length;i++)
            {
                hrView =  new HumanResourceView(humanResources[i],HumanResourceData.getIndexOf(humanResources[i]),$scope);
                $scope.dd.view.humanResourcesView.push(hrView);
            }
            $scope.dd.view.hsHr =  $scope.dd.view.humanResourcesView.length > 0;
            var physicalResources =  PhysicalResourceData.getActiveList();
            var prView;
            for(var i=0;i<physicalResources.length;i++)
            {
                prView =  new PhysicalResourceView(physicalResources[i],PhysicalResourceData.getIndexOf(physicalResources[i]),$scope);
                $scope.dd.view.physicalResourcesView.push(prView);
            }
            $scope.dd.view.hsPr =  $scope.dd.view.physicalResourcesView.length > 0;
            var categories = CategoryData.getDeletedList();
            var parentCatView;
            for (var i=0;i<categories.length;i++)
            {
                if (categories[i].parentCategory)
                    parentCatView =  $scope.getCategoryView(categories[i].parentCategory);
                else
                    parentCatView =null;
                $scope.dd.view.deletedCategoriesView.push(new CategoryView(categories[i],CategoryData.getIndexOf(categories[i]),parentCatView,$scope))
            }
            var services = ServiceData.getDeletedList();
            for (var i=0;i<services.length;i++)
            {
                if (services[i].parentCategory)
                    parentCatView =  $scope.getCategoryView(services[i].parentCategory);
                else
                    parentCatView =null;
                $scope.dd.view.deletedServicesView.push(new ServiceView(services[i],ServiceData.getIndexOf(services[i]),parentCatView,$scope))
            }

            $scope.dd.view.filterTypeService = $scope.dd.view.filterTypeServiceList.allServices;

            BasicAuthRole.GOOGLE_ROLE.loadingMethod = $scope.loadServiceSettingsReserveWithGoogleView;
            BasicAuthRole.LE_CISEAU_ROLE.loadingMethod = $scope.loadServiceSettingsLeCiseauView;
        }
    });

    $scope.addServiceViewIndex  = function(serviceView)
    {
        $scope.dd.view.servicesViewIndex.push(serviceView);
    };
    $scope.getServiceView = function (service)
    {
        return $scope.dd.view.categoryRootView.getServiceView(service)
    }
    $scope.getProductView = function (product)
    {
        return $scope.dd.view.productCategoryRootView.getProductView(product)
    }
    $scope.getCfgClass   = function(confItem,className)
    {
        if (confItem==$scope.dd.view.displaySubConf)
            return className;
        return "";
    };
    $scope.getHumanResourcesView = function()
    {
        return $scope.dd.view.humanResourcesView;
    }
    $scope.getPhysicalResourcesView = function()
    {
        return $scope.dd.view.physicalResourcesView;
    }
    $scope.getHasHr = function ()
    {
        return $scope.dd.view.humanResourcesView && $scope.dd.view.humanResourcesView.length!=0;
    }

//CATEGORY


    $scope.getCategoryView = function (category)
    {
        //Assume view index = model index
        var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category)
        if (!categoryView) //must be deleted then instanciate it
        {
            var parentCategoryView = null;
            if (category.parentCategory)
                parentCategoryView = this.getCategoryView(category.parentCategory)
            categoryView =  new CategoryView(category,CategoryData.getIndexOf(category),parentCategoryView,this);

        }
        return categoryView;
    };
    $scope.createCategory  = function(parentCategoryView)
    {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.serviceView)
            if ($scope.dd.view.edited.serviceView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
            {
                $scope.dd.view.edited.serviceView = null;
            }

        var categoryView = new CategoryView(null,-1,parentCategoryView,$scope);
        if (parentCategoryView)
        {
            if(parentCategoryView.image)
                categoryView.setImage(parentCategoryView.image);

            $scope.dd.view.edited.categoryView = categoryView;
            parentCategoryView.addCategoryView(categoryView);
        }
    };

    $scope.setCurrentCategory  = function(category)
    {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.serviceView)
            if ($scope.dd.view.edited.serviceView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
            {
                $scope.dd.view.edited.serviceView = null;
            }

        if($scope.dd.view.edited.categoryView)
            $scope.dd.view.edited.categoryView = null;

        $scope.dd.view.selected.categoryView = category;

        if (!$scope.dd.view.filter || $scope.dd.view.filter.length < 2) {
            $scope.updateVisibilityCategoriesAndServices();
        }
    };
    $scope.setEditedCategory  = function(categoryView)
    {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.serviceView)
            if ($scope.dd.view.edited.serviceView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
            {
                $scope.dd.view.edited.serviceView = null;
            }

        $scope.dd.view.edited.categoryView = categoryView;

        if ($scope.dd.view.tab>2)
            $scope.dd.view.tab =1;
    };

    $scope.saveEditedCategory = function() {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.categorySaving = true;
            $scope.dd.view.edited.categoryView.updateModel($scope.closeCategoryView, $scope.closeCategoryView);
        }
    };

    $scope.closeCategoryView = function() {
        $scope.dd.view.categorySaving = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };

    $scope.cancelEditedCategory   = function()
    {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.afterRemoveCategory  = function(category)
    {
        if (!category.parentCategory)//Remove from $scope
        {
            var index = $scope.categoryRoot.categories.indexOf(category);
            if (index!=-1)
                $scope.categoryRoot.categories.splice(index,1);
            $scope.currentCategory = null;
        }
    };
    $scope.openDeletedCategoryViewConfirmDialog  = function()
    {
        if ($scope.dd.view.edited.categoryView)
        {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        var tableModel = [] ;
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    }}};

            var d = $dialog.dialog(opts);
            d.open().then(function(result){
                if (result)
                    $scope.removeEditedCategory();
            });
        }
    };
    $scope.removeEditedCategory  = function()
    {
        if ($scope.dd.view.edited.categoryView)
        {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView)
                parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }

    };
    $scope.openDuplicateCategoryViewConfirmDialog  = function()
    {
        if ($scope.dd.view.edited.categoryView)
        {
            let label = gettextCatalog.getString( "Voulez vous dupliquer la catégorie \"" + $scope.dd.view.edited.categoryView.label + "\"?");
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        var tableModel = [] ;
                        tableModel["question"] = label;
                        return tableModel;
                    }}};

            let d = $dialog.dialog(opts);
            d.open().then(function(result) {
                if (result) {
                $scope.dd.view.isDuplicatingCategory = true;
                $scope.dd.view.edited.categoryView.countCurrentServices(function() {
                    $scope.duplicateCategory();
                    },
                    function (data, maxServices) {
                        if (data && data.numberOfCurrentServices && data.numberOfCurrentServices > maxServices) {
                            $scope.openErrorDialog(gettextCatalog.getString("Duplication impossible, le compte a plus de 1000 prestations."));
                        } else {
                            $scope.openErrorDialog(gettextCatalog.getString("Une erreur s'est produite, impossible de dupliquer la catégorie."));
                        }
                        $scope.dd.view.isDuplicatingCategory = false;
                    });
                }
            });
        }
    };
    $scope.duplicateCategory = function() {
        $scope.dd.view.edited.categoryView.duplicateCategory(function () {
            $scope.confirmDialogAndReload(gettextCatalog.getString("La copie est terminée. Veuillez recharger la page."));
            $scope.dd.view.isDuplicatingCategory = false;
        }, function () {
            $scope.openErrorDialog(gettextCatalog.getString("La copie a échoué. Veuillez recharger la page."));
            $scope.dd.view.isDuplicatingCategory = false;
        })
    };

    $scope.confirmDialogAndReload = function (message) {
        let label = gettextCatalog.getString(message),
            opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/refreshDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        tableModel["label"] = label;
                        return tableModel;
                    }
                }
            },
            d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                document.location.reload();
            }
        });
    };

    $scope.openErrorDialog = function (errorMessage) {
        let label = gettextCatalog.getString(errorMessage),
            opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/errorDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        tableModel["label"] = label;
                        return tableModel;
                    }
                }
            },
            d = $dialog.dialog(opts);
        d.open();
    };

    $scope.getClassForActiveCategory = function(category,className)
    {
        ////console.log("getClassForActive" + service.id);
        if (category === $scope.dd.view.edited.categoryView)
            return className;
        return "";
    };


    $scope.restoreCategory  = function(categoryView) {
        if (categoryView) {
            if (categoryView.catIndex!=-1)// retrieve old value from server
                categoryView.restoreModel();
            let index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
            if (index!=-1)
            {
                $scope.dd.view.deletedCategoriesView.splice(index,1);
                if (categoryView.parentCategoryView)
                    categoryView.parentCategoryView.addCategoryView(categoryView)
            }


        }

    };

    $scope.getClassForActiveService = function(service,className) {
        ////console.log("getClassForActive" + service.id);
        if (service === $scope.dd.view.edited.serviceView)
            return className;
        return "";
    };

    $scope.createService  = function(isPackage) {
        if ($scope.dd.view.edited.categoryView)
            if ($scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            else
                $scope.dd.view.edited.categoryView = null;

        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        var categoryView = $scope.dd.view.selected.categoryView;
        if (categoryView.catIndex==-1)
        {
            alert("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des prestations.")
            return;
        }
        var newServiceView =   new ServiceView(null,-1,categoryView,$scope);
        newServiceView.isPackage = isPackage;
        categoryView.addServiceView(newServiceView);

        if (categoryView.image && categoryView.image !== null)
            newServiceView.setImage(categoryView.image);

        $scope.setEditedService(newServiceView);
    };

    $scope.serviceClicked = function(serviceView) //Function linked to servicesSelector.html
    {
        $scope.setEditedService(serviceView);
    };
    $scope.setEditedService = function(serviceView) {
        if ($scope.dd.view.edited.categoryView)
            if ($scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            else
                $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.view.edited.serviceView = serviceView;

        for (let basicAuthRole in BasicAuthRole) {
            if (BasicAuthRole.hasOwnProperty(basicAuthRole)) {
                if ($scope.ad.addons.sub[BasicAuthRole[basicAuthRole].storeAppCode] && BasicAuthRole[basicAuthRole].loadingMethod !== undefined) {
                    BasicAuthRole[basicAuthRole].loadingMethod();
                }
            }
        }

        $scope.dd.view.tab = 1;

        if (serviceView) {
            serviceView.initSkills($scope.dd.view.humanResourcesView, $scope.dd.view.physicalResourcesView);
        }
    };
    $scope.duplicateService = function(serviceView)
    {
        if ($scope.dd.view.edited.categoryView)
            if ($scope.dd.view.edited.categoryView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
                $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.view.edited.serviceView = serviceView.getClone();
        if ($scope.dd.view.edited.serviceView.label) {
            $scope.dd.view.edited.serviceView.label = "Copie de " + $scope.dd.view.edited.serviceView.label;
        }
        if ($scope.dd.view.edited.serviceView.labelShort) {
            $scope.dd.view.edited.serviceView.labelShort = "Copie de " + $scope.dd.view.edited.serviceView.labelShort;
        }
        if (serviceView.parentCategoryView) {
            serviceView.parentCategoryView.addServiceView($scope.dd.view.edited.serviceView);
            if (serviceView.parentCategoryView.image && serviceView.parentCategoryView.image !== null)
                $scope.dd.view.edited.serviceView.setImage(serviceView.parentCategoryView.image);
        }

    };

    $scope.saveEditedService = function () {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.serviceSaving = true;
            $scope.dd.view.edited.serviceView.updateModel(
                function (serviceResponse) {
                    let service = ServiceData.getById(serviceResponse.id);
                    $scope.dd.view.edited.serviceView.serviceId = serviceResponse.id;
                    if (service) {
                        for (let basicAuthRole in BasicAuthRole) {
                            if(BasicAuthRole.hasOwnProperty(basicAuthRole)) {
                                let role = BasicAuthRole[basicAuthRole].role;
                                if ($scope.dd.view.edited.serviceView.serviceSettings.hasOwnProperty(role)) {
                                    let subscription = BasicAuthRole[basicAuthRole].storeAppCode;
                                    let serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[role];
                                    if ($scope.ad.addons.sub[subscription] && serviceSettings.view) {
                                        if (serviceSettings.id) {
                                            serviceSettings.view.updateModel(service.id);
                                        } else if (serviceSettings.view.isVisibleOnPartner) {
                                            serviceSettings.view.createModel(service);
                                        }
                                        serviceSettings.view = null;
                                    }
                                }
                            }
                        }
                    }
                    $scope.closeServiceView();
                }
                , $scope.closeServiceView);
        } else {
            $scope.dd.view.edited.serviceView.updateModel($scope.closeServiceView);
        }
    };

    $scope.closeServiceView = function()
    {
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.serviceView = null;
        $scope.displayChangeMsg = false;
        $scope.dd.view.serviceSaving = false;
    };

    $scope.cancelEditedService = function()
    {
        const previousLabelShort = $scope.dd.view.edited.serviceView.labelShort;
        $scope.dd.view.edited.serviceView.reloadModel();
        $scope.updateLinkedServicesLabels(previousLabelShort);
        for (let serviceSettings in $scope.dd.view.edited.serviceView.serviceSettings) {
            if($scope.dd.view.edited.serviceView.serviceSettings.hasOwnProperty(serviceSettings) && $scope.dd.view.edited.serviceView.serviceSettings[serviceSettings].view){
                $scope.dd.view.edited.serviceView.serviceSettings[serviceSettings].view.reloadModel();
                $scope.dd.view.edited.serviceView.serviceSettings[serviceSettings].view = null;
            }
        }
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.serviceView = null;
        $scope.displayChangeMsg = false;
    };

    $scope.openDeletedServiceViewConfirmDialog = function() {
        var message = "";
        var cureId = "";
        if ($scope.dd.view.edited.serviceView) {
            var service = ServiceData.getById($scope.dd.view.edited.serviceView.serviceId);

            if($scope.dd.view.edited.serviceView.serviceId == "" || $scope.dd.view.edited.serviceView.serviceId == null){
                message = message = "Etes-vous sûr de vouloir supprimer " + $scope.dd.view.edited.serviceView.label + "?";
            }
            else {
                if (service.cures.length != 0) {
                    for (var i = 0; i < service.cures.length; i++) {
                        if (service.cures[i].serviceTab.length == 1) {
                            message = "Cette prestation est l'unique prestation d'une cure, si vous la supprimez la cure sera inutilisable et ne sera plus affichée sur votre site internet. Souhaitez-vous la supprimer? "
                            cureId = service.cures[i].id;
                            break;
                        }
                        else {
                            message = "Cette prestation est liée à une cure, si vous la supprimez la cure sera inutilisable. Souhaitez-vous la supprimer? "
                        }
                    }
                }
                else {
                    message = "Etes-vous sûr de vouloir supprimer " + service.label + "?";
                }
            }
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirmTraitement.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        var tableModel = [];
                        tableModel["label"] = message;
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result)
                    $scope.removeEditedService(cureId,service);
            });
        }
    };

    $scope.removeEditedService  = function(cureId, service) {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.edited.serviceView.removeModel();

            if (service && service.cures) {
                for (let i = 0; i < service.cures.length; i++) {
                    if (service.cures[i] && service.cures[i].id === cureId) {
                        service.cures[i].isVisibleOnWebSite = false;

                        if (service.cures[i].serviceTab) {
                            for (let j = 0; j < service.cures[i].serviceTab.length; j++) {
                                if (service.cures[i].serviceTab[j].id === $scope.dd.view.edited.serviceView.serviceId) {
                                    service.cures[i].serviceTab.splice(j, 1)
                                }
                                CureSrv.save(service.cures[i]);
                            }
                        }
                    }
                }
            }

            let parentCategoryView = $scope.dd.view.edited.serviceView.parentCategoryView;
            if (parentCategoryView) {
                parentCategoryView.removeServiceView($scope.dd.view.edited.serviceView);
            }

            $scope.dd.view.deletedServicesView.push($scope.dd.view.edited.serviceView);
            $scope.dd.view.edited.serviceView = null;
            $scope.displayChangeMsg = false;
        }
    };

    $scope.restoreService  = function(serviceView)
    {
        if (serviceView)
        {
            if (serviceView.servIndex!=-1)// retrieve old value from server
                serviceView.restoreModel();
            var index = $scope.dd.view.deletedServicesView.indexOf(serviceView);
            if (index!=-1)
            {
                $scope.dd.view.deletedServicesView.splice(index,1);
                if (serviceView.parentCategoryView)
                    serviceView.parentCategoryView.addServiceView(serviceView)
            }

        }

    };


//Assign image


    $scope.imageIsSelected = function(image)
    {
        if ($scope.dd.view.edited.serviceView)
        {
            if (!$scope.dd.view.edited.serviceView.companyImage && $scope.dd.view.edited.serviceView.image===image)
                return true
        }
        else
            if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image===image)
                return true

        return false;
    };

    $scope.companyImageIsSelected = function(companyImage)
    {
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.companyImage===companyImage)
            return true
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage===companyImage)
            return true
        return false;
    };
    $scope.setImage  = function(image)
    {
        if($scope.dd.view.edited.serviceView)
        {
            if(image === $scope.dd.view.edited.serviceView.image)
            {
                if($scope.dd.view.edited.serviceView.image != null)
                {
                    $scope.dd.view.edited.serviceView.setImage(null);
                }
                else
                {
                    $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
                }
            }
            else if(image != null)
            {
                $scope.dd.view.edited.serviceView.setImage(image);
            }
            else
            {
                $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
            }
        }

        if($scope.dd.view.edited.categoryView)
        {
            if(image === $scope.dd.view.edited.categoryView.image)
            {
                if($scope.dd.view.edited.categoryView.image != null)
                {
                    $scope.dd.view.edited.categoryView.setImage(null);
                }
                else
                {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            }
            else if(image != null)
            {
                $scope.dd.view.edited.categoryView.setImage(image);
            }
            else
            {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
    };
    $scope.setCompanyImage  = function(companyImage)
    {
        if($scope.dd.view.edited.serviceView)
        {
            if(companyImage === $scope.dd.view.edited.serviceView.companyImage)
            {
                if($scope.dd.view.edited.serviceView.companyImage != null)
                {
                    $scope.dd.view.edited.serviceView.setCompanyImage(null);
                }
                else
                {
                    $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
                }
            }
            else if(companyImage != null)
            {
                $scope.dd.view.edited.serviceView.setCompanyImage(companyImage);
            }
            else
            {
                $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
            }
        }

        if($scope.dd.view.edited.categoryView)
        {
            if(companyImage === $scope.dd.view.edited.categoryView.companyImage)
            {
                if($scope.dd.view.edited.categoryView.companyImage != null)
                {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                }
                else
                {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            }
            else if(companyImage != null)
            {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            }
            else
            {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
    };

    $scope.getEditedItem = function(){
        return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : ($scope.dd.view.edited.serviceView ? $scope.dd.view.edited.serviceView : null);
    };

    $scope.onSearchServiceInputKeyDown = function()
    {
        if ($scope.dd.view.categoryRootView )
        {
            $scope.dd.view.filterServicesView = null;
            if ($scope.dd.view.filterTimeOut)
                $timeout.cancel($scope.dd.view.filterTimeOut);
            $scope.dd.view.filterTimeOut = $timeout(function() { //useTimeOut in order to search only when use finish typing (or barcode scanner stop)
                if ($scope.dd.view.filter && $scope.dd.view.filter.length>2)
                    $scope.dd.view.filterServicesView = $scope.dd.view.categoryRootView.getServicesViewByLabel($scope.dd.view.filter.toLowerCase());
            }, 250);
        }
    };

    $scope.addServiceViewDisplayed = function(serviceView) {
        if (serviceView && $scope.dd.view.filterServicesView && $scope.dd.view.filterServicesView.indexOf(serviceView) === -1) {
            $scope.dd.view.filterServicesView.push(serviceView);
        }
    };

    $scope.loadEnabledServiceSettingsReserveWithGoogleViews = function(){
        $scope.dd.view.categoriesLoading = true;
        let filterLabel = $scope.dd.view.filter.toLowerCase()
        ServiceSrv.loadEnabledServiceSettingsReserveWithGoogleViews(
            function (data) {
                $scope.dd.view.filterServicesView = [];
                if (data && $scope.dd.view.categoryRootView) {
                    for (let i = 0; i < data.length; i++) {
                        let serviceView = $scope.dd.view.categoryRootView.getServiceViewById(data[i].id);
                        if(serviceView){
                            if((filterLabel && serviceView.label.toLowerCase().indexOf(filterLabel) !== -1) || (!filterLabel) ){
                                $scope.addServiceViewDisplayed(serviceView);
                            }
                        }
                    }
                }
                $scope.dd.view.categoriesLoading = false;
            },
            function(){
                $scope.dd.view.categoriesLoading = false;
            }
        );
    };

    $scope.updateVisibilityCategoriesAndServicesForRwg = function(){
        $scope.dd.view.categoriesLoading = true;
        ServiceSrv.loadEnabledServiceSettingsReserveWithGoogleViews(
            function (data) {
                if (data) {
                    $scope.updateRecursivelyVisibilityCategoriesAndServicesForRwg($scope.dd.view.selected.categoryView,data);
                }
                $scope.dd.view.categoriesLoading = false;
            },
            function(){
                $scope.dd.view.categoriesLoading = false;
            }
        );
    };

    $scope.updateRecursivelyVisibilityCategoriesAndServicesForRwg = function(categoryParentView,data){
        let isVisibleCategory = false;
        for (let i = 0; i < categoryParentView.servicesView.length; i++){
            let serviceView = categoryParentView.servicesView[i];
            let isVisibleService = false;
            for (let k = 0; k < data.length; k++) {
                if (data[k].id == serviceView.serviceId) {
                    isVisibleCategory = true;
                    isVisibleService = true;
                    break;
                }
            }
            serviceView.isVisible = isVisibleService;
        }
        for(let j = 0; j < categoryParentView.categoriesView.length; j++) {
            isVisibleCategory = $scope.updateRecursivelyVisibilityCategoriesAndServicesForRwg(categoryParentView.categoriesView[j],data) || isVisibleCategory;
        }
        categoryParentView.isVisible = isVisibleCategory;
        return isVisibleCategory;
    };

    $scope.updateVisibilityCategoriesAndServicesForWebSite = function(categoryParentView){
        let isVisibleCategory = false;
        for (let i = 0; i < categoryParentView.servicesView.length; i++){
            let serviceView = categoryParentView.servicesView[i];
            if (serviceView && serviceView.isVisibleOnWebSite && serviceView.isBookableOnWebSite) {
                isVisibleCategory = true;
                serviceView.isVisible = true;
            }
            else{
                serviceView.isVisible = false;
            }
        }
        for(let j = 0; j < categoryParentView.categoriesView.length; j++) {
            isVisibleCategory = $scope.updateVisibilityCategoriesAndServicesForWebSite(categoryParentView.categoriesView[j]) || isVisibleCategory;
        }
        categoryParentView.isVisible = isVisibleCategory;
        return isVisibleCategory;
    };

    $scope.updateVisibilityCategoriesAndServices = function (){
        if ($scope.dd.view.filterTypeService  === $scope.dd.view.filterTypeServiceList.reserveWithGoogle) {
            $scope.updateVisibilityCategoriesAndServicesForRwg();
        }
        else if ($scope.dd.view.filterTypeService  === $scope.dd.view.filterTypeServiceList.website) {
            $scope.updateVisibilityCategoriesAndServicesForWebSite($scope.dd.view.selected.categoryView);
        }
    };

    $scope.resetVisibilityCategoriesAndServices = function(categoryParentView){
        for (let i = 0; i < categoryParentView.servicesView.length; i++){
            categoryParentView.servicesView[i].isVisible = true;
        }
        for(let j = 0; j < categoryParentView.categoriesView.length; j++) {
             $scope.resetVisibilityCategoriesAndServices(categoryParentView.categoriesView[j]);
        }
        categoryParentView.isVisible = true;
    };

    $scope.onSearchService = function()
    {
        if(!$scope.ad.offerManager.hasCompanyAccessToOnlineReservation($scope.ad.loggedUser.company)){
            $scope.onSearchServiceInputKeyDown();
        }
        else{
            if (!$scope.dd.view.filter || $scope.dd.view.filter.length < 2) {
                if ($scope.dd.view.filterTypeService  === $scope.dd.view.filterTypeServiceList.allServices) {
                    $scope.resetVisibilityCategoriesAndServices($scope.dd.view.selected.categoryView);
                }
                else{
                    $scope.updateVisibilityCategoriesAndServices();
                }
            }else{
                if ($scope.dd.view.filterTimeOut)
                    $timeout.cancel($scope.dd.view.filterTimeOut);
                $scope.dd.view.filterTimeOut = $timeout(function() { //useTimeOut in order to search only when use finish typing (or barcode scanner stop)
                    if ($scope.dd.view.filterTypeService  === $scope.dd.view.filterTypeServiceList.reserveWithGoogle) {
                        $scope.loadEnabledServiceSettingsReserveWithGoogleViews();
                    }
                    else{
                        $scope.dd.view.filterServicesView = [];
                        let servicesViewByLabel =  $scope.dd.view.categoryRootView.getServicesViewByLabel($scope.dd.view.filter.toLowerCase());
                        for (let i = 0; i < servicesViewByLabel.length; i++){
                            let serviceViewByLabel = servicesViewByLabel[i];
                            if (($scope.dd.view.filterTypeService === "" || $scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.allServices ||
                                ($scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.website && serviceViewByLabel.isVisibleOnWebSite && serviceViewByLabel.isBookableOnWebSite))) {
                                $scope.addServiceViewDisplayed(serviceViewByLabel);
                            }
                        }
                    }
                }, 250);
            }
        }
    };

    $scope.loadServiceSettingsReserveWithGoogleView = function () {
        if ($scope.dd.view.edited.serviceView) {
            let service = $scope.dd.view.edited.serviceView.getModel();
            let serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[BasicAuthRole.GOOGLE_ROLE.role];
            if (service && service.serviceSettingsReserveWithGoogleId) {
                if (serviceSettings.view) {
                    $scope.dd.view.edited.serviceView.onVisibleOnPartnerChange(BasicAuthRole.GOOGLE_ROLE.role);
                } else {
                    $scope.dd.view.serviceLoading = true;
                    ServiceSettingsReserveWithGoogleSrv.get(service.serviceSettingsReserveWithGoogleId,
                        function (serviceSettingsReserveWithGoogle) {
                            if ($scope.dd.view.edited.serviceView) {
                                serviceSettings.view = new ServiceSettingsReserveWithGoogleView(serviceSettingsReserveWithGoogle);
                                serviceSettings.id = service.serviceSettingsReserveWithGoogleId;
                                $scope.dd.view.serviceLoading = false;
                                $scope.dd.view.edited.serviceView.onVisibleOnPartnerChange(BasicAuthRole.GOOGLE_ROLE.role);
                                $scope.maybeInitAlertMessagePaymentOnline();
                            }
                        },
                        function () {
                            serviceSettings.view = new ServiceSettingsReserveWithGoogleView(null, $scope.dd.view.edited.serviceView.price);
                            $scope.dd.view.serviceLoading = false;
                        });
                }
            } else {
                if (!serviceSettings.view) {
                    serviceSettings.view = new ServiceSettingsReserveWithGoogleView(null, $scope.dd.view.edited.serviceView.price);
                }
                $scope.maybeInitAlertMessagePaymentOnline();
            }
        }
    };

    $scope.displayLeCiseauTab = function () {
        let launchDarklyFeatureFlag = LaunchDarklyFeatureFlagData.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_3534_FEATURE_FLAG_LE_CISEAU_SERVICE_SETTINGS.flagName);
        return (!launchDarklyFeatureFlag || !launchDarklyFeatureFlag.isActive) && $scope.ad.addons.sub.optionLeCiseau;
    };

    $scope.loadServiceSettingsLeCiseauView = function () {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.serviceLoading = true;
            if (!$scope.dd.view.marketplaceData.loaded) {
                $scope.initMarketplaceData().then($scope.loadServiceSettingsLeCiseauViewAfterMarketplaceLoad);
            } else {
                $scope.loadServiceSettingsLeCiseauViewAfterMarketplaceLoad();
            }
        }
    };

    $scope.loadServiceSettingsLeCiseauViewAfterMarketplaceLoad = function() {
        let service = $scope.dd.view.edited.serviceView.getModel();
        let serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[BasicAuthRole.LE_CISEAU_ROLE.role];
        if (service) {
            ServiceSettingsLeCiseauSrv.get(service.id,
                function (serviceSettingsLeCiseau) {
                    if ($scope.dd.view.edited.serviceView) {
                        serviceSettings.view = new ServiceSettingsLeCiseauView(serviceSettingsLeCiseau, service.id, $scope.dd.view.marketplaceData.defaultData);
                        serviceSettings.id = service.id;
                        $scope.dd.view.edited.serviceView.onVisibleOnPartnerChange(BasicAuthRole.LE_CISEAU_ROLE.role);
                        $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
                        $scope.dd.view.serviceLoading = false;
                    }
                },
                function () {
                    serviceSettings.view = new ServiceSettingsLeCiseauView(null, service.id, $scope.dd.view.marketplaceData.defaultData);
                    $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
                    $scope.dd.view.serviceLoading = false;
                });
        } else if (!serviceSettings.view) {
            serviceSettings.view = new ServiceSettingsLeCiseauView(null, null, $scope.dd.view.marketplaceData.defaultData);
            $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
            $scope.dd.view.serviceLoading = false;
        }
    };

    $scope.maybeInitAlertMessagePaymentOnline = function() {
        if ($scope.ad.addons.sub.websitePaymentAccess) {
            $scope.dd.view.edited.serviceView.initAlertMessagePaymentOnline();
        }
    };

    $scope.initMarketplaceData = function() {
        return MarketplaceSrv.getMarketplaceData().then(
                data => {
                    if (data && data.marketplaceCategories) {
                        $scope.dd.view.marketplaceData.marketplaceCategories = data.marketplaceCategories;
                        $scope.dd.view.marketplaceData.defaultData.marketplaceDefaultCategory = data.marketplaceCategories[0];
                        $scope.dd.view.marketplaceData.defaultData.marketplaceDefaultSubCategory = data.marketplaceCategories[0].subCategories[0];
                        $scope.dd.view.marketplaceData.defaultData.marketplaceDefaultVariant = data.marketplaceCategories[0].variants[0];
                        $scope.dd.view.marketplaceData.loaded = true
                    }
                },
                () => {
                    $scope.dd.view.marketplaceData.loaded = false;
                });
    };

    $scope.onMarketplaceCategoryChange = function(serviceSettings) {
        if (serviceSettings.view) {
            $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
            if ($scope.dd.view.marketplaceData.marketplaceSubCategories && $scope.dd.view.marketplaceData.marketplaceSubCategories.length > 0) {
                serviceSettings.view.marketplaceSubCategoryId = $scope.dd.view.marketplaceData.marketplaceSubCategories[0].id;
            } else {
                serviceSettings.view.marketplaceSubCategory = null;
            }

            if ($scope.dd.view.marketplaceData.marketplaceVariants && $scope.dd.view.marketplaceData.marketplaceVariants.length > 0) {
                serviceSettings.view.marketplaceVariantId = $scope.dd.view.marketplaceData.marketplaceVariants[0].id;
            } else {
                serviceSettings.view.marketplaceVariant = null;
            }
        }
    };

    $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory = function (marketplaceCategoryId) {
        for (let marketplaceCategory of $scope.dd.view.marketplaceData.marketplaceCategories) {
            if (marketplaceCategoryId === marketplaceCategory.id) {
                $scope.dd.view.marketplaceData.marketplaceSubCategories = marketplaceCategory.subCategories;
                $scope.dd.view.marketplaceData.marketplaceVariants = marketplaceCategory.variants;
                break;
            }
        }
    };

    $scope.computeVariantLabelById = function(variantId) {
        let label = "";
        for (let variant of $scope.dd.view.marketplaceData.marketplaceVariants) {
            if (variant.id === variantId) {
                label = variant.label;
                break;
            }
        }
        return label;
    }

    $scope.updateLabelAndLinkedServices = function() {
        $scope.updateLabelFromLabelShort($scope.dd.view.edited.serviceView, $scope.dd.view.edited.serviceView.previousLabelShort);
        $scope.updateLinkedServicesLabels($scope.dd.view.edited.serviceView.previousLabelShort);
        $scope.dd.view.edited.serviceView.previousLabelShort = $scope.dd.view.edited.serviceView.labelShort ? $scope.dd.view.edited.serviceView.labelShort : "";
    };

    $scope.updateLinkedServicesLabels = function(previousLabelShort) {
        let serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[BasicAuthRole.LE_CISEAU_ROLE.role];
        if (serviceSettings && serviceSettings.view && serviceSettings.view.hasLinkedServiceIds()) {
            serviceSettings.view.linkedServiceIds.forEach(linkedServiceId => {
                let service = ServiceData.getById(linkedServiceId);
                if (service) {
                    service.labelShort = $scope.dd.view.edited.serviceView.labelShort;
                    $scope.updateLabelFromLabelShort(service, previousLabelShort);
                    let serviceView = $scope.dd.view.selected.categoryView.getServiceView(service);
                    if (serviceView) {
                        serviceView.labelShort = $scope.dd.view.edited.serviceView.labelShort;
                        $scope.updateLabelFromLabelShort(serviceView, previousLabelShort);
                    }
                }
            });
        }
    };

    $scope.updateLabelFromLabelShort = function(service, previousLabelShort) {
        previousLabelShort = previousLabelShort ? previousLabelShort : "";
        if (service.labelShort) {
            service.label = service.label.replace(previousLabelShort, service.labelShort);
        } else {
            service.label = service.label.replace(previousLabelShort, "");
        }
    };

    $scope.clearVariants = function (service) {
        service.label = service.labelShort ? service.labelShort : "";
    }
}])



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/serviceCtrl.js